export default {
  resource:{
    zh: {
      detail: "详细",
      title: "考勤",
      companyNo: "公司",
      companyName: "公司",
      dept: "部门",
      deptNo: "部门",
      xgroup: "组别",
      duty: "职务",
      job: "岗位",
      xdate: "日期",
      xdate1: "开始日期",
      xdate2: "结束日期",
      empId: "工号",
      empName: "姓名",
      shiftName: "班次",
      shiftNo: "班次编号",
      lateTime: "迟到",
      earlyTime: "早退",
      workTime: "工作",
      absenceTime: "缺勤",
      absentDay: "旷工",
      overTime: "加班",
      leaveTime: "请假",
      paidLeaveTime: "有薪假",
      holidayTime: "放假",
      restTime: "调休",
      injuryTime:"工伤",
      sj1: "时间1",
      sj2: "时间2",
      sj3: "时间3",
      sj4: "时间4",
      sj5: "时间5",
      sj6: "时间6",
      sj7: "时间7",
      sj8: "时间8",
      day: "星期",
      day1: "日",
      day2: "一",
      day3: "二",
      day4: "三",
      day5: "四",
      day6: "五",
      day7: "六",
      isLock: "锁定",
      xxrCdsj: "休息日迟到时间",
      xxrZtsj: "休息日早退时间",
      actualGzsj: "实际工作时间",
      actualJbsj: "实际加班时间",
      isOt: "申请加班标志",
      otOver: "超时加班",
      idExist: "部门序号或名称已经存在，请检查！",
      nameExist: "部门已经存在，请检查！",
      download: "下载考勤记录",
      downloadTitle: "设置下载任务，一分钟后自动从考勤机下载考勤记录到考勤系统",
      create: "生成考勤",
      createTitle: "把原始打卡记录统计并生成考勤记录",
      fillCard: "批量补卡",
      fillCardTitle: "为缺勤的员工补回打卡记录",
      deleteRc: "删除考勤",
      DealWithAtt:"月份考勤处理",
      DealWithAttTitle: "月份考勤处理",
      deleteRcTitle: "删除选中的考勤记录",
      lock: "锁定",
      lockTitle: "锁定选中的考勤记录，重新生成不会改变且不能删除",
      cancelLock: "解锁",
      cancelLockTitle: "取消锁定选中的考勤记录",
      selFist: "请先选择记录！",
      ls: "锁定成功！",
      us: "解锁成功！",
      fillDate: "补卡日期",
      zdbc: "指定班次",
      ncfLock: "覆盖锁定的记录",
      notFound: "员工不存在，请检查！",
      nullTime: "请先选择要补的时间！",
      nullBc: "请先选择班次！",
      nullTimex: "请先输入时间！",
      nullDept: "请先选择部门！",
      nullGn: "请先添加员工！",
      nullDate: "请先输入日期！",
      nullGDate: "开始日期和结束日期不能为空！",
      nullXbc: "请先选择班次！",
      rcCard: "打卡记录",
      nrcCard: "第二天打卡",
      rcQJ: "请假",
      rcTX: "调休",
      rcOther: "其他",
      other: "其他",
      lateDay: "迟到天数",
      earlyDay: "早退天数",
      holidayDay: "休假天数",
      restDay: "调休天数",
      holidayOTDay: "无休假天数",
      holidayOT: "无休假小时",
      absenceDay: "缺勤天数",
      injuryDay:"工伤天数",
      fillCardTimes:"补卡次数"


    }
  },
  delConf:["xdate", "empName"],
  delKeys:["autoid"],
  hideButton:["View"],
  params: {
    companyNo:{
      key: "companyNo",
      defaultIdx: 0,
      method: "Contains",
      type: "select",
      options:"company"
    },
    xdate1:{
      key: "xdate",
      tkey: "xdate1",
      data: null,
      method: "GreaterThanOrEqual",
      type: "date"
    },
    xdate2:{
      key: "xdate",
      tkey: "xdate2",
      data: null,
      method: "LessThanOrEqual",
      type: "date"
    },
    empId:{
      key: "empId",
      data: null,
      method: "Equal",
      type: "text"
    },
    empName:{
      key: "empName",
      data: null,
      more: true,
      method: "Contains",
      type: "text"
    },
    dept:{
      key: "deptNo",
      data: "",
      more: true,
      method: "Equal",
      type: "select",
      options:[{
        value: "",
        text: "All"
      }],
      onchange:function(param,config){
        this.$getData(
          config.url + "GetGroup?deptNo=" + param.data,
          (data)=>{
            if (data && data.rs) {
              const arr = [{
                value: "",
                text: "All"
              }]
              if (data.xgroup && data.xgroup.length>0){
                data.xgroup.forEach(d=>{
                        arr.push({value: d, text:d})
                      })
              }
              config.params.xgroup.options = arr
            }
          }
        )
      }
    },
    xgroup:{
      key: "xgroup",
      data: "",
      more: true,
      method: "Equal",
      type: "select",
      options:[{
        value: "",
        text: "All"
      }]
    },
    shiftNo:{
      key: "shiftNo",
      tkey: "shiftName",
      data: "",
      more: true,
      method: "Equal",
      type: "select",
      options:[{
        value: "",
        text: "All"
      }]
    }
  },
  listDefine: [
    "dept","xgroup","job",{key:"empId",width:70},{key:"empName",width:80},{key: "xdate",formatter: "fdate"},
    {key:"shiftName",vformatter:"fshift", width:120},
    {key: "workTime",formatter: "fstime",width:70 },{key: "overTime",formatter: "fstime",width:70 },{key: "lateTime",formatter: "fstime",width:70 },
    {key: "earlyTime",formatter: "fstime",width:70 },{key: "absenceTime",formatter: "fstime",width:70 },
    {key: "absentDay",formatter: "fstime",width:70 },
    { key: "restTime", formatter: "fstime", width: 70 },
    { key: "leaveTime", formatter: "fstime", width: 70 },
    { key: "paidLeaveTime", formatter: "fstime", width: 70 },
    { key: "holidayTime", formatter: "fstime", width: 70 },
    { key: "injuryTime", formatter: "fstime", width: 70 },
    "fillCardTimes", "other",
    {key: "sj1",formatter: "fstime",width:70 },{key: "sj2",formatter: "fstime",width:70 },
    {key: "sj3",formatter: "fstime",width:70 },{key: "sj4",formatter: "fstime",width:70 },
    {key: "sj5",formatter: "fstime",width:70 },{key: "sj6",formatter: "fstime",width:70 },
    {key: "sj7",formatter: "fstime",width:70 },{key: "sj8",formatter: "fstime",width:70 },
    //{key: "xxrjb",formatter: "fstime"},{key: "jjrjb",formatter: "fstime"},"jbts","zbcs","ybcs","bycs","cq","qj", 
    {key: "day", formatter: "fday"},"isLock",
    //{key: "rxgz",formatter: "fstime"},{key: "user1",formatter: "fstime"},
    //,{key: "xxrCdsj",formatter: "fstime"},{key: "xxrZtsj",formatter: "fstime"},{key: "actualGzsj",formatter: "fstime"}, {key: "actualJbsj",formatter: "fstime"},"isOt",    {key: "otOver",formatter: "fstime"}
  ],
  rowStyler(index, item){
    if (item.isLock){ 
      return "background-color: rgb(169, 129, 129);"
    }
    else return ""
  },
  isShowMore: true,
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  checkList:[],
  defaultSortName: "xdate",
  defaultSortOrder: "asc",
  sortName: "xdate",
  sortOrder: "asc",
  pageNo: 1,
  pageSize: 18,
  rowCount: 127,
  url: "attendance/",
  formatter: {
    fday(t) {
      return 'day' + t
    }, 
    fshift(v, cl, item){
      const s = item["shiftNo"]
      const n = item["shiftName"]
      if (!s && !n) return ""
      return s + (s? "/" + n : "")
    }
  }
}
